
const currency = window.calc_currency || 'грн';
export const locale = {
    'ru-ru' : {

        mode : {
              default : {
                  title : 'Обогрев края <br>кровли',
              },
              drain : {
                  title : 'Обогрев желобов и водостоков'
              },
              pavement : {
                  title : 'Обогрев тротуаров'
              }

        },
        stepInfo : {
            calculation_mode : {
                title : 'Тип просчета'
            },

            //roof
            roofing_material : {
                title : 'Материал кровли:',
                description : `<p>Необходимая мощность обогрева:
                               
                                <br>1) <b>металлическая</b> - 300 Вт/м.кв
                                <br>2) <b>черепица</b> - 350 Вт/м.кв
                                <br>3) <b>мягкая</b> - 400 Вт/м.кв
                               
                                </p>
                                `,
            },
            roofing_lenght_and_heating_width : {
                title : 'Длина кровли и ширина обогрева',
                description : `<p>
                                    <b>Ширина обогрева</b> - расстояние до снегозадержаталей или холодная часть кровли
                                </p>
                                `,
            },
            //drain
            chute_total_length_and_deain_height : {
                title : 'Суммарная длина желоба и высота водостока',
                description : `<p><b>Указывается длина одного 
                        водостока.</b> Если их несколько - 
                        каждый добавляется через
                        кнопку "+"</p>`
            },


            //pavement
            heating_appointment : {
                title : 'Где будет использоваться обогрев:',
                description : ''
            },
            insulation_presence : {
                title : 'Наличие утеплителя: (полистерол)',
                description : `Рекомендуемая мощность системы:<br>
                                •	Нет утеплителя – <b>350 Вт/м.кв</b><br>
                                •	1 см – <b>320 Вт/м.кв</b><br>
                                •	5 см – <b>250 Вт/м.кв</b><br>
                                `,
            },
            heating_square : {
                title : 'Обогреваемая площадь',
                description :   `Если планируется <b>обогрев теневой и солнечной стороны</b>, то для правильной работы системы необходимо <b>каждую зону просчитывать отдельно.</b>`,
            },
            //
            product_list : {
                title: 'Вам идеально подходит:',
                sub_title :'Выберите какой-то вариант, чтобы посмотреть краткую [info_ico] информацию  о нем (справа)',
                description: {
                    description: {
                        heating_mat: `<p><b>Нагревательный мат</b> - двужильный
                                нагревательный кабель, диаметром
                                3.5 - 4.5 мм, уложенный витками на
                                армирующей сетке с определенным
                                шагом укладки. Укладывается на готовую
                                стяжку и утапливается в слой плиточного
                                клея, не поднимая уровень пола.
                                </p>
                                <p>
                                <b>ПРЕИМУЩЕСТВА:</b><br>
                                1) Нагрев плитки за 30 мин<br>
                                2) Армирует плиточный клей<br>
                                3) Простой и быстрый монтаж.<br>
                                </p>`,
                        heating_cable: `
                                <p>
                                <b>Нагревательный кабель в стяжку</b> - двухжильный греющий кабель, диаметром 5.5 - 8 мм, предназначенный для укладки в стяжку от 3 см по любое напольное покрытие.
                                Благодаря изменению шага укладки кабеля есть возможность варьировать мощность теплого пола на 1 м.кв.</p>
                                <p><b>ПРЕИМУЩЕСТВА:</b><br>
                                1) Кабель залитый в стяжку -  вечная конструкция<br>
                                2) Цена - дешевле, чем другие варианты теплого пола<br>
                                3) Дольше сохраняет тепло в помещение.<br>
                                </p>`,
                        aluminum_mat: `
                                <p><b>Алюминиевый нагревательный мат</b> - это ультратонкий нагревательный кабель, диаметром 1.5 -1.7 мм, уложенный между 2-мя слоями алюминиевый фольги. Укладывается на обычную подложку с под ламината, под сам ламинат.</p>
                
                                <p><b>ПРЕИМУЩЕСТВА:</b><br>
                                1) Простота - не требует заливки плиточного клея или стяжки<br>
                                2) Безопасность - есть заземление и защитный экран от электромагнитных излучений<br>
                                3) Надежность – не боится перегрева.<br>
                                </p>`,
                    }
                }
            }
        },
        criteriaValues : {
            //roof
            metalic: 'Металлическая',
            natural_tile: 'Натуральная черепица',
            soft_roof: 'Мягкая кровля',
            roofing_length_placeholder: 'Пример: 45',
            roofing_length_title: 'Длина кровли, м.',
            heating_width_placeholder: 'Пример: 0.5',
            heating_width_title: 'Ширина обогрева, м.',

            //drain
            chute_total_length_title : 'Суммарная длина желоба, м.',
            chute_total_length_placeholder : 'Пример: 45',
            drain_height_title:'Высота водостока, м.',
            drain_height_placeholder : 'Пример: 4',

            //pavement
            open_area : 'Открытая площадка',
            ramps : 'Пандусы',
            drive_way : 'Подьездная дорога',
            stairs : 'Ступены',
            pavement : 'Тротуар',
            path : 'Дорожки',
            no_isulation : 'Нет утеплителя',
            one_sm_isulation : '1 см утеплителя',
            fifth_sm_isulation : '5 см утеплителя',
            heating_square_placeholder : 'Пример: 8.6',



        },

        stepStat : 'й вопрос из',
        noProducts : {
            heating : 'Нет кабелей для отображения',
            reg : 'Нет терморегуляторов для отображения'
        },
        textChoseReg : 'Выберите терморегулятор',
        totalAmount : 'Общая стоимость:',
        heating_type_title : {
          heating_mat : 'Тонкий нагревательный мат под плитку',
          heating_cable : 'Нагревательный кабель',
          aluminum_mat : 'Алюминиевый нагревательный мат'
        },
        buttons : {
            prev : 'Назад',
            next : 'Дальше',
            addToCart : 'Добавить в корзину',
            getPromo : 'Получить промокод',
        },
        currency : currency
    },
    'ua-uk' : {

        mode : {
            default : {
                title : 'Обігрів краю покрівлі',
            },
            drain : {
                title : 'Обігрів жолобів і водостіків'
            },
            pavement : {
                title : 'Обігрів тротуарів'
            }

        },
        stepInfo : {
            calculation_mode : {
                title : 'Тип розрахунку'
            },

            //roof
            roofing_material : {
                title : 'Матеріал покрівлі:',
                description : `<p>Необхідна потужність обігріву:
                               
                                <br>1) <b>металева</b> - 300 Вт / м.кв 
                                <br>2) <b>черепиця</b> - 350 Вт / м.кв 
                                <br>3) <b>м'яка</b> - 400 Вт / м.кв
                               
                                </p>
                                `,
            },
            roofing_lenght_and_heating_width : {
                title : 'Довжина покрівлі і ширина обігріву',
                description : `<p>
                                    <b>Ширина обігріву</b> - відстань до снігоутримувачів або холодна частина покрівлі
                                </p>
                                `,
            },
            //drain
            chute_total_length_and_deain_height : {
                title : 'Сумарна довжина жолоба і висота водостоку',
                description : `<p><b>Вказується довжина одного водостоку.</b> 
                                Якщо їх кілька - кожен додається через кнопку "+"
                                </p>`
            },


            //pavement
            heating_appointment : {
                title : 'Де буде використовуватися обігрів:',
                description : ''
            },
            insulation_presence : {
                title : 'Наявність утеплювача: (полістерол)',
                description : `Рекомендована потужність системи:<br>
                                • Немає утеплювача - <b>350 Вт / м.кв</b><br>
                                • 1 см - <b>320 Вт / м.кв</b><br>
                                • 5 см - <b>250 Вт / м.кв</b><br>
                                `,
            },
            heating_square : {
                title : 'Площа обігріву',
                description :   `Якщо планується <b>обігрів тіньової і сонячної сторони</b>, то для правильної роботи системи необхідно <b>кожну зону прораховувати окремо.</b>`,
            },
            //
            product_list: {
                title: 'Вам ідеально підходить:',
                sub_title :'Виберіть якийсь варіант, щоб подивитися коротку [info_ico] інформацію про нього (праворуч)',
                description: {
                    heating_mat: `<p><b>Нагрівальний мат</b> - двожильний
                                нагрівальний кабель, діаметром
                                3.5 - 4.5 мм, покладений витками на
                                армуючої сітки з певним
                                кроком укладання. Укладається на готову
                                стяжку і топиться в шар плиткового
                                клею, не піднімаючи рівень підлоги.
                                </p>
                                <p>
                                <b>ПЕРЕВАГИ:</b><br>
                                1) Нагрівання плитки за 30 хв<br>
                                2) Армує плитковий клей<br>
                                3) Простий і швидкий монтаж.<br>
                                </p>`,
                    heating_cable: `
                                <p>
                                <b>Нагрівальний кабель в стяжку</b> - двожильний нагрівальний кабель, діаметром 5. 5 - 8 мм, призначений для укладання в стяжку від 3 см по будь-яке підлогове покриття.
                                Завдяки зміні кроку укладання кабелю є можливість варіювати потужність теплої підлоги на 1 м. Кв.</p>
                                <p><b>ПЕРЕВАГИ:</b><br>
                                1) Кабель залитий в стяжку - вічна конструкція<br>
                                2) Ціна - дешевше, ніж інші варіанти теплої підлоги<br>
                                3) Довше зберігає тепло в приміщення.<br>
                                </p>`,
                    aluminum_mat: `
                                <p><b>Алюмінієвий нагрівальний мат</b> - це ультратонкий нагрівальний кабель, діаметром 1. 5 -1. 7 мм, покладений між 2-ма шарами алюмінієвий фольги. Укладається на звичайну підкладку з під ламінату, під сам ламінат.</p>
                                <p><b>ПЕРЕВАГИ:</b><br>
                                1) Простота - не вимагає заливки плиткового клею або стяжки<br>
                                2) Безпека - є заземлення і захисний екран від електромагнітних випромінювань<br>
                                3) Надійність - не боїться перегріву.<br>
                               </p>`,
                }
            },
        },
        criteriaValues : {
            //roof
            metalic: 'Металева',
            natural_tile: 'Натуральна черепиця',
            soft_roof: 'М\'яка покрівля',
            roofing_length_placeholder: 'Наприклад: 45',
            roofing_length_title: 'Довжина покрівлі, м.',
            heating_width_placeholder: 'Наприклад: 0.5',
            heating_width_title: 'Ширина обігріву, м.',

            //drain
            chute_total_length_title : 'Сумарна довжина жолоба, м.',
            chute_total_length_placeholder : 'Наприклад: 45',
            drain_height_title:'Висота водостоку, м.',
            drain_height_placeholder : 'Наприклад: 4',

            //pavement
            open_area : 'Відкритий майданчик',
            ramps : 'Пандуси',
            drive_way : 'Під\'їзна дорога',
            stairs : 'Сходинки',
            pavement : 'Тротуар',
            path : 'Доріжки',
            no_isulation : 'Немає утеплювача',
            one_sm_isulation : '1 см утеплювача',
            fifth_sm_isulation : '5 см утеплювача',
            heating_square_placeholder : 'Приклад: 8.6',



        },


        stepStat : 'е питання з',
        noProducts : {
            heating : 'Ні теплих підлог для відображення',
            reg : 'Немає терморегуляторів для відображення'
        },
        textChoseReg : 'Виберіть терморегулятор',
        totalAmount : 'Загальна вартість:',
        heating_type_title : {
            heating_mat : 'Тонкий нагрівальний мат під плитку',
            heating_cable : 'Нагрівальний кабель',
            aluminum_mat : 'Алюмінієвий нагрівальний мат'
        },
        buttons : {
            prev : 'Назад',
            next : 'Далі',
            addToCart : 'Додати в кошик',
            getPromo : 'Отримати промокод',
        },
        currency : currency
    },
};